import { createSelector } from 'reselect';

import {
  hasUserSelector,
  notificationsSelector,
} from '../../../selectors/frameData';
import { propSelector } from '../../../selectors';

export default createSelector(
  propSelector,
  hasUserSelector,
  notificationsSelector,
  (props, hasUser, notifications) => ({ ...props, hasUser, notifications })
);
